<div
	[class.disabled-container]="isDisabled"
	class="color-picker-block"
>
	<!-- Color input form field -->
	<input
		class="color-picker"
		type="color"
		#colorInput
		name="custom-color"
		[id]="id"
		[disabled]="isDisabled"
		[(ngModel)]="value"
		(ngModelChange)="onColorChange($event)"
	/>

	<label
		class="color-picker-icon"
		[class.dark-color]="isDarkColor"
		[for]="id"
	>
		<ng-fa-icon
			icon="eye-dropper"
			[fixedWidth]="false"
		></ng-fa-icon>
	</label>
</div>
